module.exports = __webpack_public_path__ + "static/media/logo_lc.464b15a3.png";